/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { featureProfileConfig } from '../../config/featuresSection.config';

export interface IFeatureProfilePluginMethods extends IPluginMethodMap {
  getFeatureProfileSync(args?: any): any;
}

export class FeatureProfilePlugin implements IAgentPlugin {
  readonly methods: IFeatureProfilePluginMethods;

  constructor() {
    this.methods = {
      getFeatureProfileSync: this.getFeatureProfileSync.bind(this),
    };
  }

  async getFeatureProfileSync(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));

    return {
      feature: featureProfileConfig,
    };
  }
}
